import { Component } from '@angular/core';
import { ToastService } from './toast.service';
import { AppToast, ToastType } from './toast.model';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
  standalone: false,
})
export class ToastContainerComponent {
  readonly toasts$ = this.toastService.toasts$;

  constructor(private readonly toastService: ToastService) {}

  dismiss(id: string): void {
    this.toastService.dismiss(id);
  }

  icon(type: ToastType): string {
    return {
      success: 'mdi-check',
      error: 'mdi-close',
      warning: 'mdi-alert-outline',
      info: 'mdi-information-outline',
    }[type];
  }

  trackToast(_: number, toast: AppToast): string {
    return toast.id;
  }
}
